module.exports = __webpack_public_path__ + "img/saphybrislogo-002.62b27514.jpg";